import React from 'react';
import { NavLink } from 'react-router-dom';

import ReferenceLinkContainer from './containers/ReferenceLinkContainer';

const Sidebar = () => {
	return (
		<nav className="sidebar">
			<h2></h2> {/* What to call this section?? */}
			<div className="scroll">
				{/* HTML Links */}
				<div className="nav-links">
					<div className="nav-link"><NavLink to={'/javascript-sdk/intro'}>Introduction</NavLink></div>
					<div className="nav-link"><NavLink to={'/javascript-sdk/environment'}>Environment</NavLink></div>
					<div className="nav-link"><NavLink to={'/javascript-sdk/promise'}>Promise Objects</NavLink></div>
					<div className="nav-link"><NavLink to={'/javascript-sdk/error'}>Error Objects</NavLink></div>
					<div className="nav-link"><NavLink to={'/javascript-sdk/auth'}>Authentication &amp; Security</NavLink></div>
					<div className="nav-link">
						<NavLink to={'/javascript-sdk/reference'}>Reference</NavLink>
						<div className="route-links">
							<ReferenceLinkContainer method="changePassword" />
							<ReferenceLinkContainer method="currentUser" />
							<ReferenceLinkContainer method="geos" />
							<ReferenceLinkContainer method="leaderboard" />
							<ReferenceLinkContainer method="leaderboardRankings" />
							<ReferenceLinkContainer method="login" />
							<ReferenceLinkContainer method="loginWithToken" />
							<ReferenceLinkContainer method="logout" />
							<ReferenceLinkContainer method="post" />
							<ReferenceLinkContainer method="postUrl" />
							<ReferenceLinkContainer method="profileUrl" />
							<ReferenceLinkContainer method="putUser" />
							<ReferenceLinkContainer method="reactToPost" />
							<ReferenceLinkContainer method="reportPostViewEvent" />
							<ReferenceLinkContainer method="sharePost" />
							<ReferenceLinkContainer method="socialLogin" />
							<ReferenceLinkContainer method="socialProviders" />
							<ReferenceLinkContainer method="stream" />
							<ReferenceLinkContainer method="updateUserNotificationPreferences" />
							<ReferenceLinkContainer method="user" />
							<ReferenceLinkContainer method="userAddChannel" />
							<ReferenceLinkContainer method="userNotificationPreferences" />
							<ReferenceLinkContainer method="userNotificationsResendSmsCode" />
						</div>
					</div>
				</div>
			</div>
		</nav>
	);
};

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/javascript-sdk/Sidebar.js